import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { environment } from '../environments/environment';
import {
  provideDarkTheme,
  remoteConfigProviders,
  SOFTLINE_CONFIG_DEFAULT_THEME,
  SOFTLINE_CONFIG_THEMES,
} from '@softline/application';
import {
  accountContextProviders,
  contextSettingsProviders,
  settingsProviders,
  userContextProviders,
  utilitiesProviders,
} from '@softapps/allgemein/utils';
import { passwordProviders } from '@softapps/allgemein/password';
import { loginProviders, withLogin } from '@softapps/allgemein/login';
import { moduleProviders } from '@softapps/allgemein/modules';
import { wwsCoreProviders } from '@softapps/wws/core';
import { bestellvorschlagProviders } from '@softapps/mde/bestellvorschlag';
import { bestellerfassungProviders } from '@softapps/mde/bestellerfassung';
import { etikettendruckProviders } from '@softapps/mde/etikettendruck';
import { inventurProviders } from '@softapps/mde/inventur';
import { warenverprobungProviders } from '@softapps/mde/warenverprobung';
import { retourenProviders } from '@softapps/mde/retouren';
import { artikelInfoProviders } from '@softapps/wws/artikel-info';
import { platform } from '../platforms/platform';
import { provideSoftApps } from '@softapps/core';
import { stempelerfassungProviders } from '@softapps/pms/stempelerfassung';
import {
  pmsStempelTerminalProviders,
  SOFTLINE_CONFIG_PMS_STEMPELTERMINAL_CONFIG,
} from '@softapps/pms/stempel-terminal';
import { provideStorageLocation } from '@softapps/mde/storage-location';
import { provideEslConfigModule } from '@softapps/handel/esl-config';
import {
  provideEslLinkStorageProviders,
  provideEslSearchProviders,
} from '@softapps/handel/esl-link-storage';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter([...routes]),
    provideSoftApps(
      { connection: environment.connection, theme: 'lagerhaus' },
      withLogin()
    ),
    // provideUiCore(),
    /*importProvidersFrom(
      BrowserAnimationsModule,
      RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking' }),

      // Framework
      CoreModule.forRoot(),
      StoreModule.forRoot(),
      ConnectionModule.forRoot(environment.connection),
      AuthenticationModule.forRoot(),
      JwtAuthenticationModule.forRoot(),
      ApplicationModule.forRoot(),
      AppearanceModule.forRoot(),
      DynamicModule.forRoot(),
      MasterDataModule.forRoot(),
      DeveloperModule.forRoot(),
      ConsoleModule.forRoot(),
      ItemScanModule.forRoot(),
      OfflineModule.forRoot(),
      SoftappsCoreModule.forRoot()
    ),*/

    { provide: SOFTLINE_CONFIG_DEFAULT_THEME, useValue: 'lagerhaus' },
    provideDarkTheme(false),
    {
      provide: SOFTLINE_CONFIG_THEMES,
      useValue: {
        key: 'lagerhaus',
        name: 'Lagerhaus',
      },
      multi: true,
    },

    // Allgemein
    ...utilitiesProviders,
    ...contextSettingsProviders,
    ...userContextProviders,
    ...accountContextProviders,

    ...settingsProviders,
    ...remoteConfigProviders,
    ...passwordProviders,
    ...loginProviders,
    ...moduleProviders,

    // MDE
    ...wwsCoreProviders,

    ...bestellvorschlagProviders,
    ...bestellerfassungProviders,
    ...etikettendruckProviders,
    ...inventurProviders,
    ...warenverprobungProviders,
    ...retourenProviders,
    ...provideStorageLocation(),

    provideEslConfigModule(),
    provideEslLinkStorageProviders({ storageSelection: false }),
    provideEslSearchProviders(),

    ...artikelInfoProviders,

    {
      provide: SOFTLINE_CONFIG_PMS_STEMPELTERMINAL_CONFIG,
      useValue: {
        dashboardInfo: {
          title: 'Lagerhaus Hippach',
          subtitle: 'Stempelterminal',
        },
      },
    },

    ...pmsStempelTerminalProviders,

    ...stempelerfassungProviders,

    ...platform.providers,
    { provide: LOCALE_ID, useValue: 'de' },
  ],
};
